import React, { useState } from 'react';
import { toast } from 'react-toastify';
import UserService from '../../services/UserService';
import imageService from '../../services/ImageService';

const UpdateProfilePictureModal = ({ user, onClose }) => {
  const [preview, setPreview] = useState(user?.profilePicture ? imageService.getImage + user.profilePicture : null);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file)); // Use a temporary local URL for preview
      setSelectedFile(file);
    }
  };

  const handleUploadPhoto = async () => {
    if (!selectedFile) {
      toast.error('Please select a file to upload.');
      return;
    }
    try {
      const formData = new FormData();
      formData.append('image', selectedFile);
      await UserService.uploadImage(user.id, formData); // API call to update photo
      toast.success('Profile photo updated successfully.');
      onClose();
      window.location.reload(); // Optional: Refresh to reflect changes
    } catch (error) {
      toast.error(error.message || 'Failed to upload profile photo.');
    }
  };

  const handleDeletePhoto = async () => {
    try {
      await UserService.removeImage(user.id); // API call to delete photo
      toast.success('Profile photo deleted successfully.');
      setPreview(null);
      setSelectedFile(null);
    } catch (error) {
      toast.error(error.message || 'Failed to delete profile photo.');
    }
  };

  return (
    <div className="modal show d-block">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Manage Profile Picture</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body text-center">
            {preview ? (
              <img
                src={selectedFile ? preview : imageService.getImage + user.profilePicture} // Dynamically switch between local and server URL
                alt="Profile"
                className="rounded-circle mb-3"
                style={{ width: '120px', height: '120px', objectFit: 'cover' }}
              />
            ) : (
              <p>No profile picture available.</p>
            )}
            <div className="mt-3">
              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                className="form-control"
              />
            </div>
          </div>
          <div className="modal-footer">
            {preview && !selectedFile && (
              <button
                className="btn btn-danger me-auto"
                onClick={handleDeletePhoto}
              >
                Delete Photo
              </button>
            )}
            <button className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleUploadPhoto}
              disabled={!selectedFile}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateProfilePictureModal;
